__turbopack_context__.v({
  "content": "R-eGTq_content",
  "root": "R-eGTq_root",
});
